import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import { BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import Loading from '../../components/Loading';
import { useStateContext } from '../../contexts/ContextProvider';
import { AiTwotoneEdit } from 'react-icons/ai';
import ActionButton from '../../components/ActionButton';
import { MdEditNote, MdOutlineAccountBalanceWallet } from "react-icons/md";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaEdit, FaEye, FaRegFileExcel } from 'react-icons/fa';
import Alert from '../../components/Alert';
import EditExamen from './EditExamen';
import VoirExamen from './VoirExamen';
import TabHead from '../../components/TabHead';
import HourLoading from '../../components/HourLoading';

const MesExamens = () => {
  const navigate = useNavigate();
  const [examens, setExamens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const { setToken, user } = useStateContext();

  const [selectedExamen, setSelectedExamen] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [showView, setShowView] = useState(false);

  const tableRef = useRef(null);
  const [req, setReq] = useState({
    classe: '',
    scolaire: '',
    trimestre: '',
  });



  const getExamens = () => {
    setLoading(true);
    axiosClient.get('/mesexamens')
      .then((data) => {
        setExamens(data.data.examens);
        setLoading(false);
      }).catch(err => {
        const response = err.response;
        if (err.response.status === 401) {
          setToken(null);
        } else {
          if (response.status === 422) {
            setErrors(response.data.errors);

          }
          else {
            if (response.status === 403) {
              navigate('/403');
            } else {
              if (response.status === 404) {
                navigate('/404');
              }
              else {
                navigate('/500');
              }
            }
          }
        }
        setLoading(false);
      })

  }

  const closeShow = () => {
    setShowView(false);
    setSelectedExamen(null);
  }



  useEffect(() => {
    getExamens();
  }, []);
  return (
    <>
      <Header icon={<MdEditNote />} category='Page' title='Examens' titleAr={"الإمتحانات"} />
      {errors &&
        Object.keys(errors).map(key => (
          <Alert key={key} message={errors[key][0]} />
        ))
      }
      <div className='flex-col '>
        <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between'>
          <div className="flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-2">
            <div className="mt-8">
              <DownloadTableExcel
                filename="Inscriptions"
                sheet="inscriptions"
                currentTableRef={tableRef.current}
              >
                <Button color="bg-green-500" icon={<FaRegFileExcel />} size="20" text="Exporter" textColor="text-white" />
              </DownloadTableExcel>
            </div>
          </div>
        </div>

        <div className='mt-3 w-full overflow-x-auto'>
          <table ref={tableRef} className='table-auto'>
            <thead>
              <tr>
                <th><TabHead left="Classe" right="القسم" /></th>
                <th><TabHead left="Date" right="التاريخ" /></th>
                <th><TabHead left="Matière" right="المادة" /></th>
                <th><TabHead left="Heure Debut" right="بداية الوقت" /> </th>
                <th><TabHead left="Heure Fin" right="نهاية الوقت" /> </th>
                <th><TabHead left="Enseignant" right="المصحح" /></th>
                <th><TabHead left="Actions" right={"إجراء"}/></th>
              </tr>
            </thead>
            {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="9"><HourLoading /></td></tr></tbody> :
              (

                <tbody>
                  {examens && examens.map(o => (
                    <tr className={o.color} key={o.id}>
                      <td>{o.classe.libelle}</td>
                      <td>{o.dateExamen}</td>
                      <td>{o.matiere.libelle}</td>
                      <td>{o.heureDebut}</td>
                      <td>{o.heureFin}</td>
                      <td>{o.enseignant.nom}</td>
                      <td>
                        <div className="flex justify-center w-full items-center gap-2">
                          <ActionButton onClick={() => {
                            setSelectedExamen(o);
                            setShowView(true);
                          }} color="bg-green-500" icon={<FaEye />} textColor="text-white" title="Voir" />

                        </div>
                      </td>
                    </tr>
                  ))

                  }
                </tbody>
              )
            }
          </table>
        </div>

        {
          showView ? <VoirExamen selectedExamen={selectedExamen} onClose={closeShow} /> : <></>
        }
      </div>
    </>
  )
}

export default MesExamens